// src/components/Input.js
import React from 'react';

const Input = ({
  label,
  type = 'text',
  value,
  onChange,
  name,
  required = false,
  placeholder = '',
  error,
  className = '',
  ...props
}) => {
  return (
    <div className="mb-4">
      {label && (
        <label
          className="block text-sm font-medium text-content-secondary mb-1"
          htmlFor={name}
        >
          {label}
          {required && <span className="text-risk-critical ml-1">*</span>}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`
          w-full px-3 py-2 rounded-lg
          bg-input-bg border
          text-content-primary placeholder-content-muted
          focus:outline-none focus:ring-2 focus:ring-accent-cyan/50 focus:border-accent-cyan
          transition-colors
          ${error ? 'border-risk-critical' : 'border-border'}
          ${className}
        `}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-risk-critical">{error}</p>
      )}
    </div>
  );
};

export default Input;
